<template>
  <div class="financial_billing">
    <!--财务账单头部-->
    <div class="gp_rate_top clear">
      <input type="text" v-model="ordersMsg" placeholder="系统单号/提货信息">
      <div class="w_percent10">
        <el-select v-model="selectStatus"
                   collapse-tags
                   placeholder="状态">
          <el-option v-for="item in statusList"
                     :key="item.id"
                     :label="item.text"
                     :value="item.id">
          </el-option>
        </el-select>
      </div>
      <input type="text" v-model="remark" placeholder="备注">
      <span>提货日期</span>
      <div>
        <el-date-picker
          v-model.trim="pickUpStartTime"
          type="date"
          placeholder="年/月/日"
          format="yyyy/MM/dd">
        </el-date-picker>
      </div>
      <span>~</span>
      <div class="ml0">
        <el-date-picker
          v-model.trim="pickUpEndTime"
          type="date"
          placeholder="年/月/日"
          format="yyyy/MM/dd">
        </el-date-picker>
      </div>
      <span>审核时间</span>
      <div>
        <el-date-picker
          v-model.trim="checkStartTime"
          type="datetime"
          placeholder="年/月/日"
          format="yyyy/MM/dd HH:mm:ss">
        </el-date-picker>
      </div>
      <span>~</span>
      <div class="ml0">
        <el-date-picker
          v-model.trim="checkEndTime"
          type="datetime"
          placeholder="年/月/日"
          format="yyyy/MM/dd HH:mm:ss"
          default-time="23:59:59">
        </el-date-picker>
      </div>

      <button class="btn_normal ml10" @click="quaryData()">查询</button>

      <button class="btn btn_normal fr" @click="exportFinanceStatementExcel()">导出单据明细</button>
      <button class="btn btn_normal fr mr10" @click="ctrlBtn('add', null)">新增财务单</button>
    </div>

    <!--财务账单内容-->
    <div class="gp_rate_msg">
      <table class="table">
        <thead>
        <tr>
          <th><input type="checkbox" title="全选" v-model="checkAll" @click="checkOneOrAll()"/></th>
          <th>系统单号</th>
          <th>提货信息</th>
          <th>提货日期</th>
          <th>数量</th>
          <th>成本总额</th>
          <th>销售总额</th>
          <th>状态</th>
          <th>备注</th>
          <th>创建时间</th>
          <th>创建人</th>
          <th>审核时间</th>
          <th>审核人</th>
          <th>操作</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in list" :key="index">
          <td><input type="checkbox" title="选择" v-model="checkboxModel[index]"></td>
          <td>{{item.FinanceId}}</td>
          <td>{{item.TakeInfo}}</td>
          <td>{{item.TakeTime | timeday}}</td>
          <td>{{item.TotalQuantity}}</td>
          <td>{{item.TotalCostAmount}}</td>
          <td>{{item.TotalSellAmount}}</td>
          <td>{{item.StatusName}}</td>
          <td>{{item.Remark}}</td>
          <td>{{item.CreateTime | time}}</td>
          <td>{{item.CreaterName}}</td>
          <td>{{item.CheckTime | time}}</td>
          <td>{{item.CheckerName}}</td>
          <td>
            <a v-if="item.StatusName == '待提交'" @click="ctrlBtn('edit',item)">修改</a>
            <a @click="ctrlBtn('checkdetail', item)">查看明细</a>
            <!--<a v-if="item.StatusName == '待提交'" @click="commitFinanceById(item.FinanceId)">提交审核</a>-->
            <a v-if="item.StatusName == '待提交'" @click="ctrlBtn('submit',item)">提交审核</a>
            <!--<a  v-if="item.StatusName == '待审核'" @click="revokeFinanceById(item.FinanceId)">撤回</a>-->
            <a  v-if="item.StatusName == '待审核'" @click="ctrlBtn('revocation',item)">撤回</a>
            <!--<a  v-if="item.StatusName == '待审核'"@click="checkFinanceById(item.FinanceId)">审核</a>-->
            <a  v-if="item.StatusName == '待审核'" @click="ctrlBtn('check',item)">审核</a>
            <a  @click="ctrlBtn('remark', item)">备注</a>
            <!--<a v-if="item.StatusName == '待提交'"  @click="deleteFinanceById(item.FinanceId)">删除</a>-->
            <a v-if="item.StatusName == '待提交'"  @click="ctrlBtn('delete',item)">删除</a>
          </td>
        </tr>
        </tbody>
        <tbody v-if="!list.length">
        <tr>
          <td colspan="13">暂无相关信息</td>
        </tr>
        </tbody>
      </table>

      <!--分页-->
      <div class="text_right mt20" v-if="list">
        <el-pagination
          background
          :prev-text="'上一页'"
          :next-text="'下一页'"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <!--弹出框-->
    <financial-billing-embed-msg v-if="isShow"
                                 :title="dialogTitle"
                                 :showType="dialogShowType"
                                 :msg="dialogMsg" @cancelbtn="getSelectDialogEmbed"></financial-billing-embed-msg>


    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="'NOP'"></loading-dialog>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :txt="txtMsg"
                :is-suc="isSuc"
                @closebtn="closeMsgDialog"></msg-dialog>
  </div>
</template>

<script>
  import FinancialBillingEmbedMsg from './financial-billing-embed-msg';
  import LoadingDialog from '../../public-component/loading-dialog';
  import MsgDialog from '../../public-component/msg-dialog';

  export default {
    name: "financial-billing",
    components: {FinancialBillingEmbedMsg, LoadingDialog, MsgDialog},
    watch: {
      'checkboxModel': function (val) {
        let flag = true;
        val.forEach((value) => {
          if (!value) {
            flag = false;
            return flag;
          }
        });
        this.checkAll = flag;
        if (!this.checkboxModel.length) {
          this.checkAll = false;
        }
      } // 单选
    },
    data() {
      return {
        list: [], // 列表数据
        checkAll: false, // 全选
        checkboxModel: [], // checkbox框值
        ordersMsg: null, // 系统单号/提货信息
        statusList: [
          {id: null, text: '全部'},
          {id: 1, text: '待提交'},
          {id: 2, text: '待审核'},
          {id: 3, text: '已审核'}
          ], // 状态列
        selectStatus: null, // 选择的状态
        remark: null, // 备注
        pickUpStartTime: null, // 提货开始时间
        pickUpEndTime: null, // 提货结束时间
        checkStartTime: null, // 审核开始时间
        checkEndTime: null, // 审核结束时间
        dialogVisible: null, // 对话框操作
        dialogVisibleTitle: null, // 对话框title
        isLoading: false, // 是否显示加载框
        pickUpMsg: null, // 提货信息
        pickUpTime: null, // 提货时间
        getMsg: null, // 获取当前信息
        isShow: false, // 提示框显示
        dialogTitle: null, // 弹出框头部名
        dialogShowType: null, // 弹出框类型
        dialogMsg: null, // 传值给弹框
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '信息框内容', // 信息框内容
        isTip: false, // 提示框显示
        currentPage: 1, // 当前页数
        pageSize: 10, // 当前显示几条数据
        total: 0 // 总条数
      }
    },
    methods: {
      ctrlBtn(type, msg) {
        // this.dialogVisible = type;
        // this.dialogVisibleTitle = title;
        this.dialogShowType = type;
        this.dialogMsg = msg;
        this.isShow = true;
        switch(type) {
          case 'add':
            this.dialogTitle = '新增财务单';
            break;
          case 'edit':
            this.dialogTitle = '修改财务单';
            break;
          case 'remark':
            this.dialogTitle = '备注';
            break;
          case 'checkdetail':
            this.dialogTitle = '查看明细';
            break;
          case 'submit': case 'revocation': case 'check': case 'delete':
            this.dialogTitle = '提示';
            break;
        }
      },

      // 根据查询条件查询
      quaryData() {
        this.currentPage = 1;
        this.loadFinanceStatementPageList();
      },

      // 财务单 分页数据
      loadFinanceStatementPageList() {
        if (this.Global.timeFormatEight(this.pickUpStartTime) > this.Global.timeFormatEight(this.pickUpEndTime)) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '提货开始时间不能大于结束时间';
          return;
        }
        if (this.Global.timeFormatEight(this.checkStartTime) > this.Global.timeFormatEight(this.checkEndTime)) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '审核开始时间不能大于结束时间';
          return;
        }
        this.isLoading = true;
        const params = {
          IdOrName: this.ordersMsg,
          Status: this.selectStatus,
          Remark: this.remark,
          StartTime: this.Global.timeFormatEight(this.pickUpStartTime),
          EndTime: this.Global.timeFormatEight(this.pickUpEndTime),
          CheckStartTime: this.Global.timeFormatEight(this.checkStartTime),
          CheckEndTime: this.Global.timeFormatEight(this.checkEndTime),
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        };
        this.$axios.post(this.Global.loadFinanceStatementPageList, params).then((res) => {
          const self = this;
          let timer = setTimeout(function () {
            clearTimeout(timer);
            self.isLoading = false;
            if (res) {
              self.checkAll = false;
              self.checkboxModel = [];
              if (!res.data.errorMsg.length) {
                self.list = res.data.resData.DataList;
                self.total = res.data.resData.TotalCounts;
                for (let i = 0; i < res.data.resData.DataList.length; i++) {
                  self.checkboxModel.push(false);
                }
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 100)
        });
      },

      // 单选/全选
      checkOneOrAll() {
        for (let i = 0; i < this.checkboxModel.length; i++) {
          this.checkboxModel[i] = !this.checkAll;
        }
      },

      // 把财务单提交
      commitFinanceById(financeId) {
        this.$axios.post(this.Global.commitFinanceById(financeId), null).then((res) => {
          const self = this;
          let timer = setTimeout(function () {
            clearTimeout(timer);
            self.isLoading = false;
            if (res) {
              if (!res.data.errorMsg.length) {
                self.isMsg = true;
                self.isSuc = true;
                self.txtMsg = '提交成功';
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 100)
        });
      },

      // 把财务单审核
      checkFinanceById(financeId) {
        this.$axios.post(this.Global.checkFinanceById(financeId), null).then((res) => {
          const self = this;
          let timer = setTimeout(function () {
            clearTimeout(timer);
            self.isLoading = false;
            if (res) {
              if (!res.data.errorMsg.length) {
                self.isMsg = true;
                self.isSuc = true;
                self.txtMsg = '提交成功';
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 100)
        });
      },

      // 把财务单撤回
      revokeFinanceById(financeId) {
        this.$axios.post(this.Global.revokeFinanceById(financeId), null).then((res) => {
          const self = this;
          let timer = setTimeout(function () {
            clearTimeout(timer);
            self.isLoading = false;
            if (res) {
              if (!res.data.errorMsg.length) {
                self.isMsg = true;
                self.isSuc = true;
                self.txtMsg = '撤回成功';
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 100)
        });
      },

      // 删除财务单
      deleteFinanceById(financeId) {
        this.$axios.post(this.Global.deleteFinanceById(financeId), null).then((res) => {
          const self = this;
          let timer = setTimeout(function () {
            clearTimeout(timer);
            self.isLoading = false;
            if (res) {
              if (!res.data.errorMsg.length) {
                self.isMsg = true;
                self.isSuc = true;
                self.txtMsg = '删除成功';
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 100)
        });
      },

      // 保存财务单信息
      saveFinanceStatement() {
        const params = {
          FinanceId: this.getMsg, // 新增传空，编辑传账单号
          TakeInfo: this.pickUpMsg,
          TakeTime: this.Global.timeFormatEightDate(this.pickUpTime)
        };
        this.$axios.post(this.Global.saveFinanceStatement, params).then((res) => {
          const self = this;
          let timer = setTimeout(function () {
            clearTimeout(timer);
            self.isLoading = false;
            if (res) {
              if (!res.data.errorMsg.length) {
                self.isMsg = true;
                self.isSuc = true;
                self.txtMsg = '提交成功';
                self.dialogVisible = false;
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.dialogVisible = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 100)
        });
      },

      // 导出财务单
      exportFinanceStatementExcel() {
        let idList = [];
        this.checkboxModel.findIndex((val, i) => {
          if (val === true) {
            idList.push(this.list[i].FinanceId);
          }
        });
        console.log(this.checkboxModel);
        console.log(idList);
        if (!idList.length) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择要批量操作的链接';
          return;
        }
        this.isLoading = true;
        this.$axios.post(this.Global.exportFinanceStatementExcel, idList).then((res) => {
          console.log(res);
          const self = this;
          let timer = setTimeout(function () {
            clearTimeout(timer);
            self.isLoading = false;
            if (res.data) {
              if (!res.data.errorMsg.length) {
                window.open(res.data.resData, '_blank')
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 100);
        });
      },

      // 分页——当前页面显示条数改变
      handleSizeChange(val) {
        this.pageSize = val;
        this.loadFinanceStatementPageList();
      },

      // 分页——当前页改变
      handleCurrentChange(val) {
        this.currentPage = val;
        this.loadFinanceStatementPageList();
      },

      // 接收弹出框传送的数据
      getSelectDialogEmbed(e) {
        this.isShow = e.isShow;
        if (e.handleType) {
          this.loadFinanceStatementPageList();
        }
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
        if (this.isSuc) {
          this.loadFinanceStatementPageList();
        }
      }

    },
    created() {
      this.loadFinanceStatementPageList();
    },
    activated() { // 只有keep-alive激活才会被使用
      if (sessionStorage.getItem('isRefresh') === 'true') { // 从左边的菜单进去刷新页面
        sessionStorage.setItem('isRefresh', 'false');
        this.ordersMsg = null;
        this.selectStatus = null;
        this.remark = null;
        this.pickUpStartTime = null;
        this.pickUpEndTime = null;
        this.checkStartTime = null;
        this.checkEndTime = null;
        this.currentPage = 1;
        this.pageSize = 10;
        this.total = 0;
        this.loadFinanceStatementPageList();
      }
    },
    beforeRouteLeave(to, from, next) {
      to.meta.keepAlive = true;
      next();
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .financial_billing {
    background-color: #ffffff;
    height: 100%;
    position: relative;

    .gp_rate_top {
      padding: 10px 10px 0 0;

      .w85 {
        width: 85px;
      }

      input[type='text'], & > div {
        margin-left: 10px;
        display: inline-block;
        width: 140px;
        margin-bottom: 10px;
      }
    }

    .gp_rate_msg {
      height: calc(100% - 118px);
      margin: 10px 10px 0;
      overflow: auto;

      th, td {
        border: 1px solid #ddd;
      }

      a  {
        color: #169BD5;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/home/report-management/financial-billing.vue